import { CommandBase } from "../CommandBase.js";
import Sanitizer from '../../../system/security/sanitizer.js'; 

// Handles the 'ask' command (AI query)
export class AskCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        this.aiSearch = kernel.get('aiSearch');
    }
    
    // In SpecialtyCommands.js -> AskCommand

    async execute(args) {
        const query = args.join(' ');
        if (!query) {
            this.write("Usage: ask [your question]", "text-muted");
            return;
        }

        this.write("Querying CYBER-OS AI... 🧠", "text-muted");
        this.terminal.isProcessing = true;
        
        try {
            let htmlResponse = await this.aiSearch.query(query);
            
            // ✅ CLEANUP: Strip Markdown code fences if present
            htmlResponse = htmlResponse.replace(/^```html/, '').replace(/```$/, '').trim();

            // ✅ SECURITY: Sanitize
            const safeResponse = Sanitizer.sanitizeHTML(htmlResponse);
            
            // ✅ STYLING: Wrap in a container that enforces text color
            // We use 'terminal-ai-response' class which we can style, or just generic text-primary
            this.writeHTML(`<div class="terminal-line output text-primary">${safeResponse}</div>`);

        } catch (error) {
            this.write(`Error: ${error.message}`, "text-danger");
        } finally {
            this.terminal.isProcessing = false;
        }
    }
}

// Handles the 'theme' command
export class ThemeCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        this.themeManager = kernel.get('theme');
    }
    async execute(args) {
        const themeName = args[0];
        // handleThemeCommand handles the UI/State/CSS updates
        const themeMessage = await this.themeManager.handleThemeCommand(themeName, true); 
        this.write(themeMessage, themeMessage.startsWith('Error') ? 'text-red' : 'text-green');
    }
}